import ErrorPage, { ErrorPageProps } from './ErrorPage';

export type { ErrorPageProps };
export default ErrorPage;
